import "./styles.scss";

import { useEffect, useState } from "react";
import { ToastContainer, Slide, cssTransition, toast } from "react-toastify";

import useResponsive from "libs/helpers/useResponsive";

const Fade = cssTransition({
  enter: "toast-fade-in",
  exit: "toast-fade-out",
});

const NotifyContainer = ({ position }) => {
  const { max } = useResponsive();
  const [toastCount, setToastCount] = useState(0);

  useEffect(() => {
    const unsubscribe = toast.onChange((payload) => {
      setToastCount((count) =>
        payload.status === "added" ? count + 1 : Math.max(0, count - 1),
      );
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (max.sm && toastCount > 0) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [max.sm, toastCount]);

  return (
    <ToastContainer
      position={
        max.sm
          ? "bottom"
          : position || (max.lg ? "bottom-right" : "top-right")
      }
      autoClose={max.sm ? 600000 : 3000}
      hideProgressBar={false}
      stacked
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={!max.sm}
      pauseOnHover
      transition={max.sm ? Fade : Slide}
    />
  );
};

export default NotifyContainer;
